module.exports = __webpack_public_path__ + "ee52ad19bd165acbed07feafd1ea9d9a.svg";